export default {
    workOrder_changeStatus_title: "Change Status",
    workOrder_changeStatus_status: "Status",
    workOrder_changeStatus_note: "Note",
    workOrder_changeStatus_successMessage: "The status has been changed",
    workOrder_changeStatus_change: "Change",
}